import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Injectable()
export class DateHelperService {
    private readonly UiChartDateFormat: string = 'dd MMMM';
    private readonly ServerDateFormat: string = 'yyyy-MM-dd';
    private readonly MonthYearFormat = 'MMMM-yyyy';

    constructor(private datePipe: DatePipe) {
    }

    public convertBackToDateFromTicks(ticks: any): string {
        return this.datePipe.transform(new Date(ticks), this.UiChartDateFormat);
    }

    public getTicks(date: any): number {
        return new Date(date).getTime();
    }

    public formatDate(date: Date) {
        return this.datePipe.transform(date, this.ServerDateFormat);
    }

    public isToday(date: Date): boolean {
        return this.formatDate(date) === this.formatDate(new Date());
    }

    public formatMonthly(date: Date) {
        return this.datePipe.transform(date, this.MonthYearFormat);
    }

    public formatDayAndMonth(date: Date) {
        return this.datePipe.transform(date, 'dd-MMMM-yyyy');
    }

    public formatDateFromMonthYearString(date: string) {
        let d = moment(date, this.MonthYearFormat);
        return new Date(d.year(), d.month(), d.date())
    }

    public formatDateFromDayMonthYearString(date: string) {
        let d = moment(date, 'DD-MMMM-YYYY');
        return new Date(d.year(), d.month(), d.date())
    }

    public utcDateOnly(date: Date): Date {
        var _utc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
        return _utc;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/date-helper.service.ts